/** Same URL, same in-flight GET: one network round-trip. */

/** @type {Map<string, Promise<unknown>>} */
const inflightGets = new Map();

export async function withOmicsGetCoalesce(url, method, fn) {
  const m = String(method || 'GET').toUpperCase();
  const key = String(url || '');
  if (m !== 'GET' || !key.includes('/api/admin/omics/')) {
    return fn();
  }
  const existing = inflightGets.get(key);
  if (existing) {
    return existing;
  }
  const pending = Promise.resolve()
    .then(fn)
    .finally(() => {
      if (inflightGets.get(key) === pending) {
        inflightGets.delete(key);
      }
    });
  inflightGets.set(key, pending);
  return pending;
}

export function __resetOmicsGetCoalesceForTests() {
  inflightGets.clear();
}
